import { render } from "./Staked.vue?vue&type=template&id=4a108af6&scoped=true"
import script from "./Staked.vue?vue&type=script&lang=js"
export * from "./Staked.vue?vue&type=script&lang=js"

import "./Staked.vue?vue&type=style&index=0&id=4a108af6&scoped=true&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/lostsailor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a108af6"]])

export default __exports__